import React from 'react';
import { Button, IconButton } from '@fiverr-private/button';
import { SparkSolidIcon } from '@fiverr-private/visuals';
import { AppI18n } from '../../../../../i18n';

interface Props {
    disabled: boolean;
    onClick: () => void;
    loading: boolean;
}

export const ResponsiveCTAButton = ({ disabled, onClick, loading }: Props) => (
    <>
        <IconButton
            aria-label="Fiverr-ai"
            intent="primary"
            size="sm"
            disabled={disabled}
            onClick={onClick}
            loading={loading}
            hidden={{ lg: true, default: false }}
        >
            <SparkSolidIcon />
        </IconButton>
        <Button size="sm" disabled={disabled} onClick={onClick} loading={loading} hidden={{ default: true, lg: false }}>
            <SparkSolidIcon />
            <AppI18n k="prompt_box.button.text" />
        </Button>
    </>
);
